"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var diagnosis_web_socket_service_1 = require("../../service/diagnosis-web-socket.service");
var vehicle_1 = require("../../../shared/model/vehicle");
var diagnosis_general_result_1 = require("../../../shared/model/diagnosis-general-result");
var diagnosis_service_1 = require("../../service/diagnosis.service");
var diagnosis_type_1 = require("../../../shared/model/diagnosis-type");
var DiagnosisComponent = /** @class */ (function () {
    function DiagnosisComponent(_router, _diagnosisNotification, _route, _diagnosisService) {
        this._router = _router;
        this._diagnosisNotification = _diagnosisNotification;
        this._route = _route;
        this._diagnosisService = _diagnosisService;
        this.running = true;
        this.diagnosisFinished = false;
        this.hasError = false;
        this.observeRestart();
        this.setEmptyEntities();
        this.setUpDiagnosisFinished();
        this.subscribeError();
    }
    DiagnosisComponent.prototype.ngOnInit = function () {
        this.getParams();
    };
    Object.defineProperty(DiagnosisComponent.prototype, "vehicle", {
        get: function () {
            return this._vehicle;
        },
        set: function (vehicle) {
            this._vehicle = vehicle;
            this._diagnosisType = vehicle.diagnosisType;
            this.changeVehicle = this.changeVehicle === undefined ? true : this.changeVehicle;
            try {
                this.runDiagnosis();
            }
            catch (e) {
                this.goBack();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagnosisComponent.prototype, "run", {
        get: function () {
            return this._run;
        },
        set: function (run) {
            this._run = run;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagnosisComponent.prototype, "diagnosisGeneralResult", {
        get: function () {
            return this._diagnosisGeneralResult;
        },
        set: function (diagnosisGeneralResult) {
            this._diagnosisGeneralResult = diagnosisGeneralResult;
            if (!this._run) {
                this.getCoordinatesByDiagnosisId();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagnosisComponent.prototype, "applyCard", {
        get: function () {
            return this._applyCard;
        },
        set: function (applyCard) {
            this._applyCard = applyCard;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagnosisComponent.prototype, "showTitle", {
        get: function () {
            return this._showTitle;
        },
        set: function (showTitle) {
            this._showTitle = showTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagnosisComponent.prototype, "diagnosisType", {
        get: function () {
            return this._diagnosisType;
        },
        set: function (diagnosisType) {
            this._diagnosisType = diagnosisType;
        },
        enumerable: true,
        configurable: true
    });
    DiagnosisComponent.prototype.ngAfterViewInit = function () {
    };
    DiagnosisComponent.prototype.getParams = function () {
        var _this = this;
        this._route.params.subscribe(function (params) {
            if (params['data']) {
                var data = JSON.parse(params['data']);
                _this.vehicle = Object.assign(new vehicle_1.Vehicle(), data.vehicle);
                _this.vehicles = Object.assign(new Array(), data.vehicles);
                _this.showTitle = Object.assign(Boolean, data.showTitle);
            }
        });
    };
    DiagnosisComponent.prototype.runDiagnosis = function () {
        if (this.vehicle && this._run) {
            this._diagnosisNotification.run(this.vehicle);
        }
    };
    DiagnosisComponent.prototype.getCoordinatesByDiagnosisId = function () {
        var _this = this;
        this._diagnosisService.getCoordinatesFromDiagnosis(this._diagnosisGeneralResult.id)
            .subscribe(function (response) {
            _this.coordinates = Object.assign(new Array(), JSON.parse(response._body));
        }, function (error) { return _this.coordinates = undefined; });
    };
    DiagnosisComponent.prototype.getLastCoordinate = function () {
        if (this.coordinates === undefined || this.coordinates.length === 0) {
            return undefined;
        }
        return this.coordinates[this.coordinates.length - 1].position;
    };
    DiagnosisComponent.prototype.applyCardClass = function () {
        if (this._applyCard === undefined) {
            return true;
        }
        else {
            return this._applyCard;
        }
    };
    DiagnosisComponent.prototype.mustShowTitle = function () {
        if (this._showTitle === undefined) {
            return false;
        }
        else {
            return this._showTitle;
        }
    };
    DiagnosisComponent.prototype.goBack = function () {
        this._router.navigate(['diagnosis']);
        this._diagnosisNotification.back();
    };
    DiagnosisComponent.prototype.displayGeneralDiagnosis = function () {
        if (this._diagnosisType === undefined) {
            return true;
        }
        else {
            return this._diagnosisType === diagnosis_type_1.DiagnosisType.GENERAL;
        }
    };
    DiagnosisComponent.prototype.displaySimplifiedDiagnosis = function () {
        if (this._diagnosisType === undefined) {
            return false;
        }
        else {
            return this._diagnosisType === diagnosis_type_1.DiagnosisType.SIMPLIFIED;
        }
    };
    DiagnosisComponent.prototype.showRestartOption = function () {
        return !this.running && this.diagnosisFinished || this.hasError;
    };
    DiagnosisComponent.prototype.setUpDiagnosisFinished = function () {
        var _this = this;
        this._diagnosisNotification.response$
            .filter(function (response) { return response instanceof diagnosis_general_result_1.DiagnosisGeneralResult; })
            .subscribe(function (response) {
            _this.running = false;
            _this.diagnosisFinished = true;
        });
    };
    DiagnosisComponent.prototype.restartDiagnosis = function () {
        this._diagnosisNotification.restart();
        this.hasError = false;
    };
    DiagnosisComponent.prototype.observeRestart = function () {
        var _this = this;
        this._diagnosisNotification.restart$
            .subscribe(function () {
            _this.setEmptyEntities();
            _this.running = true;
        });
    };
    DiagnosisComponent.prototype.subscribeError = function () {
        var _this = this;
        this._diagnosisNotification.error$
            .subscribe(function () {
            _this.setEmptyEntities();
            _this.running = false;
            _this.hasError = true;
        });
    };
    DiagnosisComponent.prototype.setEmptyEntities = function () {
        if (this._diagnosisGeneralResult === undefined) {
            this._diagnosisGeneralResult = new diagnosis_general_result_1.DiagnosisGeneralResult();
        }
        if (this._run === undefined) {
            this._run = true;
        }
    };
    DiagnosisComponent.ctorParameters = function () { return [{ type: router_1.Router }, { type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }, { type: router_1.ActivatedRoute }, { type: diagnosis_service_1.DiagnosisService }]; };
    return DiagnosisComponent;
}());
exports.DiagnosisComponent = DiagnosisComponent;
//# sourceMappingURL=diagnosis.component.js.map


// WEBPACK FOOTER //
// diagnosis.component.js